(() => {
  if (customElements.get('sf-top-split-options')) return;
  class SplitOptions extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.picker = this.closest('hdt-variant-picker');
      this.native = this.previousElementSibling;
      this.gas = this.querySelector('[data-sf-gas]');
      this.ignition = this.querySelector('[data-sf-ignition]');
      if (!this.picker || !this.native?.hasAttribute('data-sf-top-native')) return;
      this.rows = [...this.native.querySelectorAll('input[type="radio"], hdt-richlist > button')].map(control => {
        const prefix = control.value.match(/^(Natural Gas|Liquid Propane)\s*\/\s*(.+)$/);
        const suffix = control.value.match(/^(.+?)\s*(?:\/|-)\s*(Natural Gas|Liquid Propane)$/);
        return prefix ? {gas: prefix[1], ignition: prefix[2], value: control.value, control} : suffix ? {gas: suffix[2], ignition: suffix[1], value: control.value, control} : null;
      });
      if (!this.rows.length || this.rows.some(row => !row)) return;
      for (const [key, select] of [['gas', this.gas], ['ignition', this.ignition]]) {
        select.replaceChildren(...[...new Set(this.rows.map(row => row[key]))].map(value => new Option(value, value)));
        select.addEventListener('change', event => {
          event.stopPropagation();
          this.choose(key);
        }, {signal: this.abort.signal});
      }
      customElements.whenDefined('hdt-variant-picker').then(() => this.ready(0));
    }
    ready(attempt) {
      if (!this.isConnected) return;
      if (!this.picker.masterInput) {
        if (attempt < 80) this.timer = setTimeout(() => this.ready(attempt + 1), 250);
        return;
      }
      this.form = this.picker.masterInput.form;
      this.form?.addEventListener('variant:change', () => this.sync(), {signal: this.abort.signal});
      this.picker.masterInput.addEventListener('change', () => queueMicrotask(() => this.sync()), {signal: this.abort.signal});
      this.sync();
      this.native.hidden = true;
      this.hidden = false;
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
    }
    usable(row) {
      return !row.control.classList.contains('is-unavailable') && (!this.picker.hideSoldOutVariants || !row.control.classList.contains('is-disabled'));
    }
    current() {
      const control = this.native.querySelector('input[type="radio"]:checked, input[type="hidden"][is-value]');
      return this.rows.find(row => row.value === control?.value);
    }
    sync() {
      const current = this.current();
      if (current) {
        this.gas.value = current.gas;
        this.ignition.value = current.ignition;
      }
      for (const option of this.gas.options) option.disabled = !this.rows.some(row => row.gas === option.value && this.usable(row));
      for (const option of this.ignition.options) option.disabled = !this.rows.some(row => row.gas === this.gas.value && row.ignition === option.value && this.usable(row));
    }
    choose(key) {
      const candidates = this.rows.filter(row => this.usable(row));
      const chosen = candidates.find(row => row.gas === this.gas.value && row.ignition === this.ignition.value) || candidates.find(row => row[key] === this[key].value);
      if (!chosen) { this.sync(); return; }
      if (this.current()?.value === chosen.value) { this.sync(); return; }
      const control = this.native.querySelector('input[type="hidden"][is-value]') || chosen.control;
      if (control.type === 'radio') control.checked = true;
      else control.value = chosen.value;
      control.dispatchEvent(new Event('change', {bubbles: true}));
      this.sync();
    }
  }
  customElements.define('sf-top-split-options', SplitOptions);
})();
